import axios from './axios';

const getAppConfig = () => {
    return axios.get(`/elevo/app-config`);
};

export { getAppConfig };
